export const ownerReferral = [
    'Referral from Family/Friend/Coworker',
    'Referral from your Veterinarian',
    'Search Engine (Google, Bing, Yahoo, Ecosia, Duck Duck Go, etc.)',
    'Social Media (Facebook, Instagram, Tiktok)',
    'Drove By',
    'An Employee'
]

